/**
 * Application constants
 */

/**
 * Canonical production site URL (no trailing slash)
 */
export const SITE_URL = 'https://lerusystems.com'

/**
 * Site name used in page titles and social metadata
 */
export const SITE_NAME = 'Leru Systems'

/**
 * Section IDs for navigation
 */
export const SECTION_IDS = {
  HOME: 'home',
  SERVICES: 'services',
  WHY_US: 'why-us',
  PRICING: 'pricing',
  FAQ: 'faq',
  CONTACT: 'contact',
} as const

/**
 * Breakpoint values (matching MUI theme)
 */
export const BREAKPOINTS = {
  XS: 0,
  SM: 600,
  MD: 900,
  LG: 1200,
  XL: 1536,
} as const

/**
 * Header height for scroll offset calculations
 */
export const HEADER_HEIGHT = 80

/**
 * Contact information placeholders
 */
export const CONTACT_INFO = {
  EMAIL: 'info@lerusystems.com',
  // PHONE: '(555) 123-4567',
  // BUSINESS_HOURS: 'Monday - Friday, 9am - 5pm EST',
} as const

/**
 * Social media links (placeholders)
 */
export const SOCIAL_LINKS = {
  FACEBOOK: '#',
  TWITTER: '#',
  LINKEDIN: '#',
  INSTAGRAM: '#',
} as const

/**
 * Copyright information
 */
export const COPYRIGHT = {
  YEAR: new Date().getFullYear(),
  COMPANY: 'Leru Systems',
  TEXT: `© ${new Date().getFullYear()} Leru Systems. All rights reserved.`,
} as const
